<template>
  <el-container
    ref="elementBox"
    class="landing-page-element"
  >
    <el-header class="landing-page-element-title">
      <slot name="element-title" />
    </el-header>

    <slot name="element-content" />
  </el-container>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  mounted() {
    this.$emit('update:size', { elementHeight: (this.$refs.elementBox as Vue).$el.clientHeight - 38, elementWidth: (this.$refs.elementBox as Vue).$el.clientWidth })
    window.addEventListener('resize', this.browserResized)
    window.addEventListener('transitionend', this.browserResized)
  }

  destroyed() {
    window.removeEventListener('resize', this.browserResized)
    window.removeEventListener('transitionend', this.browserResized)
  }

  private browserResized() {
    this.$emit('update:size', { elementHeight: (this.$refs.elementBox as Vue).$el.clientHeight - 38, elementWidth: (this.$refs.elementBox as Vue).$el.clientWidth })
  }
}
</script>
